import type { InventoryCategoryNode } from '@/lib/api/inventory-categories.js';

export const INVENTORY_ITEM_SECTIONS = [
  { id: 'about', label: 'About' },
  { id: 'description', label: 'Description' },
  { id: 'stock', label: 'Stock' },
  { id: 'compatible', label: 'Compatible Devices' },
  { id: 'suppliers', label: 'Suppliers' },
  { id: 'pricing', label: 'Pricing' },
  { id: 'bundle', label: 'Bundle' },
  { id: 'variants', label: 'Variants' },
  { id: 'history', label: 'History' },
] as const;

export function flattenCategories(
  nodes: InventoryCategoryNode[],
  depth = 0,
): Array<{ id: string; label: string }> {
  const out: Array<{ id: string; label: string }> = [];
  for (const n of nodes) {
    out.push({ id: n.id, label: `${'— '.repeat(depth)}${n.name}` });
    out.push(...flattenCategories(n.children ?? [], depth + 1));
  }
  return out;
}

export function str(v: unknown, fallback = ''): string {
  if (v == null) return fallback;
  return String(v);
}
